import React, { useState } from "react";
import { Box, IconButton, useMediaQuery } from "@mui/material";
import LyricsIcon from "@mui/icons-material/Lyrics";
import PhotoAlbumIcon from "@mui/icons-material/PhotoAlbum";
import CloseIcon from "@mui/icons-material/Close";
import ArtworkView from "./ArtworkView";
import LyricsView from "./LyricsView";
import { useAudio } from "@/context/AudioProvider";

type Props = {
  track: {
    id?: string;
    title?: string;
    artistName?: string;
    artwork?: string;
    albumArtwork?: string;
    albumName?: string;
    duration?: number;
    lyrics?: string;
  };
  onClose?: () => void;
};

const NowPlayingViewSwitcher: React.FC<Props> = ({ track, onClose }) => {
  const [view, setView] = useState<"artwork" | "lyrics">("artwork");
  const { state } = useAudio();
  const progress = state.progress;
  const isMobile = useMediaQuery("(max-width:768px)");

  const handleFlip = () => {
    setView((prev) => (prev === "artwork" ? "lyrics" : "artwork"));
  };

  const ToggleIcon = view === "artwork" ? LyricsIcon : PhotoAlbumIcon;

  return (
    <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
      {/* Header (Desktop Only) */}
      {!isMobile && (
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#181220",
            padding: "8px 12px",
          }}
        >
          <IconButton size="small" onClick={handleFlip} sx={{ color: "white" }}>
            <ToggleIcon fontSize="small" />
          </IconButton>
          {onClose && (
            <IconButton onClick={onClose} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      )}

      {/* Main View */}
      {view === "artwork" ? (
        <Box
        onClick={isMobile ? handleFlip : undefined}
        sx={{
          width: "100%",
          maxWidth: isMobile ? "100%" : "600px",
          aspectRatio: "1 / 1",
          maxHeight: isMobile ? "100%" : "calc(100vh - 180px)", // Prevent going under the player
          margin: "0 auto",
          cursor: isMobile ? "pointer" : "default",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
          <ArtworkView
            title={track.title}
            artworkUrl={track.artwork || track.albumArtwork}
            onClick={!isMobile ? handleFlip : undefined}
          />
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            overflowY: "auto",
            padding: isMobile ? "16px" : "0",
          }}
          onClick={isMobile ? handleFlip : undefined}
        >
          <LyricsView
            trackId={track.id}
            artist={track.artistName || ""}
            title={track.title || ""}
            albumName={track.albumName}
            duration={track.duration}
            fallbackLyrics={track.lyrics}
            progress={progress}
          />
        </Box>
      )}
    </Box>
  );
};

export default NowPlayingViewSwitcher;









